<template>
  <div class="offcanvas-body">
    <LoadingContainer v-if="loading" />
    <template v-else>
      <div v-for="(rating, index) in ratings" :key="index">
        <RatingItem
          :rating="rating"
          @handleRemove="(id: number) => onRemove(id)"
          @handleChange="
            async (item: IRating) => await handleChange(item, index)
          "
        />
      </div>
    </template>
    <ModalComponent
      title="Deseja reportar esta avaliação?"
      id="report_rating_modal"
      backdrop="false"
    >
      <template v-slot:body>
        <p class="text-paragraph">
          Esta avaliação será analisada, e se for inadequada será removida.
        </p>
        <TextAreaInput
          class="mb-0"
          :model="v$.form.reason_report"
          placeholder="Qual motivo deseja reportar?"
          :maxLength="200"
        />
      </template>
      <template v-slot:footer>
        <FormButton
          color="danger"
          fullWidth
          :form="v$.form"
          :loading="submitting"
          @onClick="handleConfirmReport"
          label="Reportar"
          :disabled="v$.$invalid"
        />
      </template>
    </ModalComponent>
  </div>
</template>

<script lang="ts">
import IRating from "@/interfaces/IRating";
import RatingsController from "./RatingsController";
export default RatingsController;
</script>
